import React from "react";

export default function NoMatch() {
  return <div>NoMatch</div>;
}
